import { useAzureSearch } from './use-azure-search.hook';
import { IConfig } from '@vivli/shared/infrastructure/interface';
import { IAuthService } from '@vivli/core/infrastructure/interface';

export const useVocabSearch = (config: IConfig) => {
    return useAzureSearch({
        config,
        indexName: 'vocab',
        quoteSearchTerms: false
    });
};
